<template>
  <div @click.stop="visible = !visible">
    <a class="flex flex-col justify-center p-4 text-center border-l border-b cursor-pointer h-full w-16 sm:w-32">
      <div class="text-2xl">
        <i class="fal fa-bars" />
      </div>
      <div class="hidden sm:block text-sm capitalize mt-3">
        <div>View</div>
        <div>Menu</div>
      </div>
    </a>
    <div class="relative" v-show="visible">
      <div class="absolute top-0 left-0 right-0 bottom-0 z-40" @click.stop="visible = false" />
      <nav
        class="inline-block absolute right-0 top-0 overflow-x-auto z-50"
        :class="authStore.isPortal ? 'bg-blue-900 text-white' : 'bg-white text-black border border-t-0'"
        style="max-height: 70vh"
      >
        <div class="flex capitalize justify-between p-3">
          <div class="whitespace-nowrap mr-5 flex flex-col justify-around">
            {{ localisedDate(new Date(), { hour: '2-digit', minute: '2-digit' }) }}
          </div>
          <div class="ml-auto">
            <a
              class="cursor-pointer hover:bg-blue-900 px-4 py-2 bg-blue-700 border border-blue-700 text-white rounded-lg flex flex-col justify-around capitalize whitespace-nowrap transition duration-500 ease-in-out"
              @click="
                $router.replace({
                  path: '/logout',
                  query: { path: authStore.superuser ? '/login-admin' : '/login' }
                })
              "
            >
              Log Out
            </a>
          </div>
        </div>

        <PortalMenuItems v-if="authStore.isPortalUser" />
        <BusinessMenuItems v-if="authStore.isBusinessUser" />
      </nav>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/pinia/auth'
import { localisedDate } from '@/utils/date'
import PortalMenuItems from '@/components/shared/nav/PortalMenuItems.vue'
import BusinessMenuItems from '@/components/shared/nav/BusinessMenuItems.vue'

export default {
  components: {
    PortalMenuItems,
    BusinessMenuItems
  },
  setup() {
    return { localisedDate }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    ...mapStores(useAuthStore)
  }
}
</script>
